import { Component } from 'react';
import { connect } from 'react-redux';

// API URL
const apiURL = process.env.REACT_APP_API_URL;



class OtherDashboard extends Component {
  state = {

  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authData.centerData.center_id !== this.props.authData.centerData.center_id) {

    }
  }

  render() {

    return (<>

    </>);
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(OtherDashboard);